import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { teamPlanSummaryQueryOptions } from '@/routes/researchers/_authenticated/projects/$projectId/-launch/team-pricing-version';

import { CreditExpirations } from './-credit-expirations';

export const Route = createFileRoute(
  '/researchers/_authenticated/billing/expirations',
)({
  component: BillingExpirationsPage,
  head: () => ({ meta: [{ title: t`Recruitment expirations` }] }),
});

function BillingExpirationsPage() {
  const { user, activeDashboard } = Route.useRouteContext();
  const teamId = activeDashboard.team ?? '';
  const {
    data: summary,
    isPending,
    isError,
  } = useQuery({
    ...teamPlanSummaryQueryOptions(teamId, user.id),
    enabled: !!teamId,
  });
  const isV3 = summary?.plan?.pricingVersion === 3;

  return (
    <>
      <h1 className="text-display-xs font-semibold text-primary">
        <Trans>Recruitment expirations</Trans>
      </h1>
      {isPending && (
        <p role="status" className="text-sm text-secondary">
          <Trans>Loading expirations…</Trans>
        </p>
      )}
      {isError && (
        <p role="alert" className="text-sm text-error-primary">
          <Trans>Could not load recruitment expirations.</Trans>
        </p>
      )}
      {!isPending && !isError && !isV3 && (
        <p role="status" className="text-sm text-secondary">
          <Trans>
            Recruitment expirations apply to current pricing plans only.
          </Trans>
        </p>
      )}
      {teamId && isV3 && <CreditExpirations teamId={teamId} userId={user.id} />}
    </>
  );
}
